"use strict";

exports.__esModule = true;
exports.AnalyticEventObserver = void 0;
var _Advert = require("../Core/Advert");
var _AdBreak = require("../Core/AdBreak");
var _Session = require("../Public/Session");
var _TrackingError = require("./TrackingError");
/*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
// JsDoc imports
/**
 * AnalyticEventObserver is the analytics observing interface to the SDK; implementers that are
 * registered with a concrete subclass of Session will receive callbacks on the methods detailed
 * below when the specified events occur.
 * @see {@link Session}.addAnalyticObserver()
 * @hideconstructor
 */
var AnalyticEventObserver = exports.AnalyticEventObserver = /*#__PURE__*/function () {
  function AnalyticEventObserver() {}
  var _proto = AnalyticEventObserver.prototype;
  /**
   * Called when an ad break starts
   * @param {AdBreak} adBreak the ad break that has started
   * @param {Session} session the Session that triggered the event
   */
  _proto.onAdvertBreakStart = function onAdvertBreakStart(adBreak, session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when an ad break ends
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onAdvertBreakEnd = function onAdvertBreakEnd(session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when an ad break returns early
   * @param {AdBreak} adBreak the ad break that has returned
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onAdvertBreakEarlyReturn = function onAdvertBreakEarlyReturn(adBreak, session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when playback of an advert ends
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onAdvertEnd = function onAdvertEnd(session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when playback of an advert starts
   * @param {Advert} advert the advert that has started
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onAdvertStart = function onAdvertStart(advert, session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Indicates that a VMAP payload was received and processed from the Central Streaming Manager during playback
   * of a stream in respect of upcoming adverts. A client can read the ad break update from the Session.
   * @see {@link Session}.getAdBreaks()
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onAnalyticUpdate = function onAnalyticUpdate(session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when a tracking URL is called against the specified Advert.
   *
   * Possible events are:
   * - `loaded`, `start`, `firstQuartile`, `midpoint`, `thirdQuartile`, `complete`
   * - `pause`, `resume`, `rewind`, `skip`, `playerExpand`, `playerCollapse`, `mute`, `unmute`
   * - `ClickTracking`, `acceptInvitation`
   *
   * @param {string} type the tracking type
   * @param {Session} session the `Session` that triggered the event
   */;
  _proto.onTrackingEvent = function onTrackingEvent(type, session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when a session reports an error
   * @param {SessionErrorCode} errorCode the error code associated with the event
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onSessionError = function onSessionError(errorCode, session) {
    throw new Error("Function must be overridden");
  }

  /**
   * Called when a session reports a tracking error
   * @param {TrackingError} trackingError the error object associated with the event
   * @param {Session} session the Session that triggered the event
   */;
  _proto.onTrackingError = function onTrackingError(trackingError, session) {
    throw new Error("Function must be overridden");
  };
  return AnalyticEventObserver;
}();